import { render } from "./resultItem.vue?vue&type=template&id=54cbb2ec&scoped=true"
import script from "./resultItem.vue?vue&type=script&lang=js"
export * from "./resultItem.vue?vue&type=script&lang=js"

import "./resultItem.vue?vue&type=style&index=0&id=54cbb2ec&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/funfindhk20250610/front-vue-src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cbb2ec"]])

export default __exports__